import { render, staticRenderFns } from "./scene-information.vue?vue&type=template&id=0dad389b&"
import script from "./scene-information.vue?vue&type=script&lang=js&"
export * from "./scene-information.vue?vue&type=script&lang=js&"
import style0 from "./scene-information.vue?vue&type=style&index=0&id=0dad389b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports